"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoPinComponentSchema = exports.VideoSourceSchema = void 0;
const zod_1 = require("zod");
const base_pin_component_1 = require("./base-pin-component");
exports.VideoSourceSchema = zod_1.z.enum(['YOUTUBE', 'VIMEO', 'SCHOOL_TV']);
const VideoSettingsSchema = base_pin_component_1.BasePinComponentSettingsSchema.merge(zod_1.z.object({
    source: exports.VideoSourceSchema.optional(), // we support a empty placeholder
    sourceId: zod_1.z.string().min(1).optional(),
    startTime: zod_1.z.number().optional(),
    endTime: zod_1.z.number().optional(),
}));
exports.VideoPinComponentSchema = base_pin_component_1.BasePinComponentSchema.merge(zod_1.z.object({
    type: zod_1.z.literal('VIDEO'),
    settings: VideoSettingsSchema,
}));
//# sourceMappingURL=video-pin-component.js.map